export const SAMPLE_EULA = `<p align="center">
<strong>
    EATON CORPORATION END USER LICENSE AGREEMENT FOR Substation Online
    Services
</strong>
</p>
<p>
This End User License Agreement (the “<strong>Agreement</strong>”) is a
legal agreement between you and the Contracting Entity (as defined below).
For the purposes of this Agreement, any reference to “Eaton” shall include
the Contracting Entity, its holding company, its affiliates and
subsidiaries. This Agreement, and any other terms or conditions notified to
you, governs your access to and use of Grid Solutions (the “    <strong>Product Software</strong>”).
</p>
<p>
Your use of the Product Software is subject to the terms of this Agreement
as set out below which includes our Privacy Statement <a href="https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html">
https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html </a>,
Cookie Statement
<a href="https://www.eaton.com/content/dam/eaton/company/policies-and-statements/privacy-notice-effective-dec-20-2019-eaton-cookies.pdf">https://www.eaton.com/content/dam/eaton/company/policies-and-statements/privacy-notice-effective-dec-20-2019-eaton-cookies.pdf <a/>,

<a name="_Hlk37853834"></a>
and any other terms or conditions of the Product Software which may be
notified to you from time to time.
</p>
<p>
By using the Product Software, you agree to us collecting and using
anonymised technical information about the devices you use the Product
Software on and related software, hardware and peripherals to improve our
products and to provide any services to you.<strong></strong>
</p>
<p>
By selecting the “I Agree” option, you agree to the terms of this
Agreement. Your right to use the Product Software is expressly conditioned
on acceptance of this Agreement.
</p>
<p>
<h3 name="_Ref56548580">1 INFORMATION ABOUT US</h3>
</p>
<p>
1.1 Cooper Industries (Electrical) Inc. is registered in Canada (company
registration number 1947312) and has its main office at 5925 McLaughlin
Road, Mississauga ON L5R 1B8, Canada (the “    <strong>Contracting Entity</strong>”).
</p>
<p>
1.2 If you have any questions about this Agreement, the Privacy Statement
or any other terms or conditions in connection with the Product Software,
please contact us at    <a href="mailto:dataprotection@eaton.com">dataprotection@eaton.com</a>.
</p>
<h3>
2 DEFINITIONS
</h3>
<p>
2.1 In this Agreement the following expressions shall have the following
meanings:
</p>
<p>
<strong>“Arbitrator” </strong>
has the meaning as defined in Clause 28.2;
</p>
<p>
<strong>“Business Day”</strong>
means a calendar day other than a Saturday, Sunday, Bank Holiday or other
statutory holiday in the jurisdiction in which the Contracting Entity is
registered;
</p>
<p>
<strong>“Contracting Entity”</strong>
has the meaning as defined in Clause 1.1;
</p>
<p>
<strong>“Credentials” </strong>
has the meaning as defined in Clause 3.7;
</p>
<p>
<strong>“Dispute” </strong>
means any claim, dispute or difference arising under or in connection with
this Agreement;<strong></strong>
</p>
<p>
<strong>“Documentation” </strong>
means any tutorials, user guides and other documents accompanying or made
available with the Product Software solely for your own internal business
purposes;
</p>
<p>
<strong>“Eaton Hardware” </strong>
means the Eaton product provided by Eaton to you, which may include Product
Software within it;
</p>
<p>
<strong>“Eaton Open Source Components”</strong>
has the meaning as defined in Clause 10.1;
</p>
<p>
<strong>“Eaton Website” </strong>
has the meaning as defined in Clause 16.1;
</p>
<p>
<strong>“Effective Date” </strong>
means the date upon which you agree to abide by the terms and conditions of
this Agreement;
</p>
<p>
<strong>“Export Laws”</strong>
has the meaning as defined in Clause 27.1;
</p>
<p>
<strong>“Fees”</strong>
has the meaning as defined in Clause 11.1;
</p>
<p>
<strong>“Feedback” </strong>
has the meaning as defined in Clause 21.2;
</p>
<p>
<strong>“Force Majeure Event”</strong>
has the meaning as defined in Clause 25.1;
</p>
<p>
<strong>“GDPR” </strong>
has the meaning as defined in Clause 19.1;
</p>
<p>
<strong>“Indemnified Parties”</strong>
has the meaning as defined in Clause 15.1;
</p>
<p>
<strong>“Intellectual Property Rights” </strong>
means any ideas (whether or not patentable), inventions, discoveries,
processes, works of authorship, marks, names, know-how, and any and all
rights in such materials throughout the world, whether existing under
statute, common law or equity, now or hereinafter recognized, including but
not limited to (i) patents, designs, inventor’s certificates, utility
models, copyrights, moral rights, trade secrets, mask works, trade names
and marks, service marks, trade dress, domain names, confidential
information and know-how; (ii) any application or right to apply for any of
the rights referred to in section (i); and (iii) all renewals, extensions,
and restorations, now or hereafter in force and effect for any of the
rights referred to in section (i);
</p>
<p>
“<strong>Materials</strong>” has the meaning as defined in Clause 21.4;
</p>
<p>
<strong>“Product Software”</strong>
means the software provided by Eaton to you, which includes any
applications, firmware and/or platforms provided to you from time to time;
</p>
<p>
<strong>“Support Services”</strong>
has the meaning defined in Clause 12.1;
</p>
<p>
<strong>“Term”</strong>
means the period of time starting on your acceptance of this Agreement, and
ending when you or the Contracting Entity terminate the Agreement as
provided herein;
</p>
<p>
<strong>“Third Party Licensors”</strong>
has the meaning as defined in Clause 9.1;
</p>
<p>
<strong>“Third Party Links and Ads”</strong>
has the meaning as defined in Clause 23.1;
</p>
<p>
<strong>“Third-Party Providers”</strong>
has the meaning as defined in Clause 21.5;
</p>
<p>
<strong>“Updates” </strong>
has the meaning as defined in Clause 6.1.
</p>
<p>
<h3 name="_Ref56548588">3 GRANT AND SCOPE OF LICENSE</h3>
</p>
<p>
3.1 In consideration of you agreeing to abide by the terms of this
Agreement, Eaton hereby grants to you, for the Term, a limited,
non-exclusive, non-transferable, non-sub-licensable, and revocable license
to access and use the Product Software, which is provided to you for your
own internal business purposes, solely for your use as permitted in these
terms.
</p>
<p>
3.2 Subject to the limited rights expressly granted above, Eaton and its
licensors or suppliers reserve all right, title and interest in and to the
Product Software, its underlying technology and all Intellectual Property
Rights therein. You acknowledge that no licenses or rights are granted to
you by implication or otherwise in respect of the Product Software, other
than those expressly set forth in this Agreement. You agree not to remove,
change or obscure any Intellectual Property Rights notices incorporated in
or accompanying the Product Software. You agree to abide by all applicable
national and international laws in connection with the use of the Product
Software, including those related to cybersecurity and piracy, data
protection, privacy, intellectual property, international communications
and the transmission of technical or personal data.
</p>
<p>
3.3 Eaton may make services available to you that are provided, in whole or
in part, by other parties. Although Eaton may offer this opportunity, you
acknowledge that any third party services that you use in connection with
the Product Software are not part of the Product Software. You further
acknowledge that these terms do not apply to any third party service
providers and that your use of those services may require you to agree to
additional terms with the third party service provider.
</p>
<p>
3.4 You shall as soon as reasonably practicable notify Eaton in writing by
email or by phone to the relevant contact information provided in the
“contact us” section below if you become aware of any use of the Product
Software other than in accordance with this Agreement and all applicable
laws, rules and regulations. Without limiting the generality of the
foregoing, you shall notify, and shall promptly notify, Eaton if you become
aware of any third party that does or attempts to: (i) de-compile or
reverse engineer the Product Software; (ii) sell, re-license, distribute or
commercially exploit the Product Software; (iii) except as expressly
permitted by this Agreement, make the Product Software available through
any means or media without the prior written approval of Eaton; (iv) except
as expressly permitted by this Agreement, copy, modify, publish, transmit,
participate in the license or re-license, transfer or sale of, reproduce,
create derivative works from, distribute, perform, display or in any way
exploit the Product Software, in whole or in part, without the prior
written consent of Eaton; and (v) engage in any activity that interferes
with or disrupts the Product Software (or the servers and networks
connected to the Product Software).
</p>
<p>
3.5 You shall not make more than one (1) copy of the Documentation for use
by you in connection with the authorized use of the Product Software and
you shall account for and number any such copy. All titles, trademarks,
copyright and restricted rights or proprietary notices included in the
Documentation shall not be removed and must be reproduced in such copy.
Additional copies may be made pursuant to a separate license.
</p>
<p>
3.6 You may be required to register to use the Product Software. If so, you
must have a valid account with a username and password (“    <strong>Credentials</strong>”). You may register for such Credentials at
the direction(s) provided with the Product Software or by an authorized
Eaton representative. The date of registration shall be the Effective Date
of this Agreement. You are responsible for maintaining the confidentiality
of your Credentials, and for ensuring that each respective password is only
used by individual employees granted access to the Product Software on your
behalf. You are liable for all transactions and other activities carried
out under your Credentials. You agree to promptly notify Eaton if any
password is lost, stolen, disclosed to an unauthorized party, or otherwise
may have been compromised. You agree to immediately notify Eaton of any
unauthorized use of your account or any other breach of security in
relation to the Product Software known to you. Eaton shall have no
liability for any loss or damage arising from your failure to comply with
these requirements or any other losses arising from such unauthorized
access. If Eaton suspends or terminates your account under this Agreement,
you acknowledge that all information and content associated with such
account will no longer be available to you.
</p>
<h3>
4 LOCATION DATA
</h3>
<p>
4.1 The Product Software may make use of location data sent from your
devices. Where applicable, you can turn off this functionality at any time
by turning off the location services settings for the Product Software on
the device. If you use the Product Software, you consent to us and our
affiliates' and licensees' transmission, collection, retention,
maintenance, processing and use of your location data and queries to
provide and improve location-based and road traffic-based products and
services.
</p>
<p>
4.2 You may stop us collecting such data at any time by turning off the
location services settings on your device.
</p>
<h3>
5 NECESSARY EQUIPMENT
</h3>
<p>
5.1 Full use of the Product Software is dependent upon your use of a device
with Internet access and the purchase of Eaton Hardware in which it is
installed or to which the Product Software pertains as described in the
Documentation.
</p>
<p>
5.2 In order for the Product Software to operate fully, your device may
need to be connected to certain wireless and/or communication based
technologies. There may be delays, limitations and other problems inherent
in the use of the Internet and wireless and/or communication based
technologies. Eaton is not responsible for any delays, failures or other
damages resulting from such problems and/or the costs/charges associated
with internet data usage.
</p>
<p>
5.3 The maintenance and security of this equipment may affect the
performance of the Product Software and it is your responsibility to ensure
the equipment’s functionality is compatible and for making all arrangements
necessary for you to have access to the Product Software.
</p>
<p>
5.4 Internet transmissions are never completely private or secure. Any
message or information you send using the Product Software may be read or
intercepted by others, even if there is a special notice that a particular
transmission is encrypted.
</p>
<h3>
6 UPDATES
</h3>
<p>
6.1 Eaton may, at its discretion, update or modify the Product Software
from time to time. You agree to accept such updates and modifications,
including any and all corrections of substantial defects, security patches,
minor bug fixes, and enhancements (“<strong>Updates</strong>”) for the
Product Software.
</p>
<p>
6.2 The provisions of this Agreement shall govern any Updates provided by
Eaton, unless such Updates are accompanied by, or references, a separate
license agreement in which case the terms of that license agreement shall
prevail.
</p>
<p>
6.3 We reserve the right, without notice to you, to update, change, and
discontinue (temporarily or permanently) any feature or component of the
Product Software. By continuing to use the Product Software you accept the
updates and changes to the Product Software including any changes to or
removal of features or components. You agree that your obligations are
neither contingent upon the delivery of any future functionality or
features nor dependent upon any oral or written comments made by us with
respect to future functionality or features. Eaton is not liable to you or
to any third party for any update, change, suspension, discontinuance of
any feature or component of the Product Software. Eaton reserves the right
to determine the timing and content of software updates, which may be
automatically downloaded and installed by the Product Software without your
notice. If you chose not to install such updates or if you opt out of
automatic updates you may not be able to continue using the Product
Software.
</p>
<h3>
7 TRANSFER AND ASSIGNMENT RESTRICTIONS
</h3>
<p>
7.1 You agree not to sell, resell, assign, lease, sub-license, encumber or
otherwise transfer your interest in this Agreement or in the Product
Software and/or Documentation, in whole or in part, or allow any other
person or entity, including any of your parent or subsidiaries or other
subsidiaries of your parent, to copy, distribute, or otherwise transfer the
Product Software without the prior written consent of Eaton.
</p>
<h3>
8 Restricted USES
</h3>
<p>
8.1 In relation to the Product Software, you warrant, represent and
undertake that you shall:
</p>
<p>
(i) only use the Product Software with the license key, if the Product
Software is subject to the use of a license key;
</p>
<p>
(ii) not license, sell, rent, lease, transfer, assign, distribute, host, or
otherwise commercially exploit the Product Software, whether in whole or in
part, or any content displayed on the Product Software except as permitted
herein;
</p>
<p>
(iii) not copy (except as expressly permitted by this Agreement), enhance,
decompile, modify, make derivative works of, disassemble, reverse compile
or reverse engineer, attempt to derive the source of code of any part of
the Product Software;
</p>
<p>
(iv) not copy (except as expressly permitted by this Agreement), reproduce,
distribute, republish, download, display, post or transmit the whole or any
part of the Product Software in any form or by any means, except as
expressly permitted in this Agreement;
</p>
<p>
(v) not use any part of the Product Software to establish any independent
data files, databases, compendiums or any other reference materials except
to the extent such foregoing restriction is prohibited by applicable laws
or applicable open source license to, and only to, any open source software
component that is incorporated into the Product Software (if any). Any
attempt to do so is a violation of the rights of Eaton;
</p>
<p>
(vi) not access or view Product Software in order to build a similar or
competitive product or service to the Product Software;
</p>
<p>
(vii) not provide false data including false names, addresses, contact
details and fraudulent credit card/debit card details;
</p>
<p>
(viii) not enter into fraudulent or deceptive interactions or transactions
with Eaton (which shall include entering into interactions or transactions
purportedly on behalf of a third party where you have no authority to bind
that third party or you are pretending to be a third party);
</p>
<p>
(ix) not use the Product Software in any way that is unlawful, fraudulent
or deceptive, or has any unlawful, fraudulent or deceptive purpose or
effect;
</p>
<p>
(x) not use the Product Software except in conjunction with the operation
of Eaton products to which the Product Software pertains or other products
described by Eaton in the Documentation;
</p>
<p>
(xi) not sell any products or services purchased through Eaton, without
Eaton’s express permission;
</p>
<p>
(xii) not intercept communications transmitted by way of a
telecommunications system and/or information society service;
</p>
<p>
(xiii) not to distribute, or otherwise provide to any third party any
registration code algorithms, registration codes, or encryption keys, where
applicable, used by or in connection with the Product Software without the
prior written consent of Eaton;
</p>
<p>
(xiv) not attempt to create any registration codes or passwords, where
applicable, to allow unauthorized activation of the Product Software, nor
shall you assist others in doing so;
</p>
<p>
(xv) not use any registration code algorithms, registration codes or
encryption keys, where applicable, that have not been purchased from Eaton
or an authorized representative of Eaton;
</p>
<p>
(xvi) not execute any form of network monitoring which will intercept data
not intended for you;
</p>
<p>
(xvii) use the Product Software in compliance with all applicable laws,
rules and regulations at all times, and be strictly in accordance with this
Agreement;
</p>
<p>
(xviii) not use the Product Software to transmit, or procure the sending
of, any unsolicited or unauthorized advertising, promotional material,
chain letters, mass mailings or any other form of similar solicitation
(spam) or of any material that is illegal, offensive, abusive, indecent,
defamatory, obscene, menacing or in breach of proprietary rights,
confidence, privacy or any other right, or is injurious to third parties.
</p>
<p>
(xix) not attempt to gain unauthorized access to the Product Software, its
facilities and/or services or any accounts, databases, computer systems,
servers and networks connected to the Product Software and the server on
which our site is stored. You shall not attack the Product Software via a
denial of service attack. You will not misuse the Product Software by
knowingly or recklessly introducing viruses, Trojans, worms, logic bombs,
harmful data or other materials which is malicious or harmful;
</p>
<p>
(xx) not use the Product Software to harvest or otherwise collect by any
means any program material or any information whatsoever (including without
limitation email addresses or other personal details of other users);
</p>
<p>
(xxi) provide Eaton with accurate and complete information and acknowledge
that Eaton’s ability to deliver the Product Software is dependent upon your
cooperation, as well as the accuracy and completeness of any information
you provide to Eaton. Eaton shall not be liable for any costs, expenses or
liabilities resulting from your failure to cooperate or to provide such
information;
</p>
<p>
(xxii) not access the Product Software through the use of any mechanism
other than through the use of an authorized connection;
</p>
<p>
(xxiii) not use any automated technology such as a robot, spider or
scraper, to access, scrape or data mine the Product Software;
</p>
<p>
(xxiv) not modify the paper or digital copies of any Materials you print or
download in any way, and you must not use any illustrations, photographs,
video or audio sequences, or any graphics separately from any accompanying
text;
</p>
<p>
(xxv) not, without Eaton’s prior express written permission, “mirror,”
screen-scrape or frame by any other similar method, any Materials contained
on this Product Software on any other server;
</p>
<p>
(xxvi) not use any part of the Materials for commercial purposes without
obtaining permission from our licensors or us. If you are in breach of
these terms of use, your right to use the Product Software will cease
immediately and you must, at our option, return or destroy any copies of
the Materials you have made;
</p>
<p>
(xxvii) use reasonable endeavours to prevent any unauthorized access to, or
use of, the Product Software and, in the event of any such unauthorized
access or use, immediately without delay notify Eaton in writing by email
or by phone to the relevant contact information provided in the “contact
us” section below.
</p>
<p>
8.2 By breaching Clause 8.1 of this Agreement, you could potentially commit
a criminal offence. We will report any such breach to the relevant law
enforcement authorities, and we will co-operate with those authorities by
disclosing your identity to them. In the event of such a breach, your right
to use the Product Software will cease immediately.
</p>
<p>
8.3 We will not be liable for any loss or damage caused by a distributed
denial of service attack, viruses or other technologically harmful material
that may infect your computer equipment, computer programs, data or other
proprietary material due to your use of the Product Software or to your
downloading of any material posted on it, or any website linked to it.
</p>
<p>
<a name="_Toc475110175"></a>
<a name="_Ref56548960"></a>
<a name="_Hlk39071131"></a>
<h3>
9 THIRD PARTY SOFTWARE
</h3>
</p>
<p>
9.1 The Product Software may contain components (including, notwithstanding
Clause 10 of this Agreement, open source software components) that are
owned by third parties (“<strong>Third Party Licensors</strong>”) and are
provided with, incorporated into, linked to, or embedded in, the Product
Software pursuant to license arrangements between Eaton and any such third
parties. Third Party Licensor components in the Product Software are not
licensed or warranted under the terms of this Agreement, but are instead
subject to any license arrangements between Eaton and any such third
parties.
</p>
<p>
9.2 You agree not to modify, delete or obfuscate any copyright or other
Intellectual Property Rights notices of Third Party Licensors contained in
the Product Software.
</p>
<p>
9.3 To the extent there are any conflicts between the terms of this
Agreement and any license arrangement between Eaton and any such third
party license corresponding to Third Party Licensor components or
additional obligations by such Third Party Licensors that are not set forth
in this Agreement, the terms of the license arrangement between Eaton and
any such Third Party Licensor or the corresponding open source license will
prevail.
</p>
<p>
9.4 This Product Software contains the known third party software
(including third party open source software components) as set out in
Appendix 1A.
</p>
<p>
<h3 name="_Ref56548893">10 OPEN SOURCE SOFTWARE</h3>
</p>
<p>
10.1 The Product Software may contain certain components owned by Eaton
that are provided with, incorporated into, linked to, or embedded in the
Product Software that are subject to open source licenses (“    <strong>Eaton Open Source Components</strong>”). To the extent there are
any conflicts between the terms of this Agreement and any open license
corresponding to Eaton Open Source Components or additional obligations by
any such open source license that are not set forth in this Agreement, the
terms of the open source license shall prevail.
</p>
<p>
10.2 This Product Software contains the known Eaton Open Source Components
as set out in Appendix 1B.
</p>
<p>
<h3 name="_Ref56548904">11 FEES</h3>
</p>
<p>
11.1 Where applicable, Eaton may charge you fees for access to the Product
Software. You agree to pay all fees and charges, within the agreed upon
billing period, including taxes, incurred through your account at the rates
in effect for the billing period in which such fees and charges are
incurred, including but not limited to, charges for any products or
services offered for sale through the Product Software by Eaton (such fees,
charges and taxes shall collectively be referred to as “    <strong>Fees</strong>”). Eaton reserves the right to change the amount of,
or basis for determining, any Fees, and to institute new Fees, effective
upon prior notice to you.
</p>
<p>
<h3 name="_Ref56548952">12 SUPPORT SERVICES</h3>
</p>
<p>
12.1 Eaton or its suppliers and distributors may provide you with support
services related to the Product Software (the “    <strong>Support Services</strong>”). Use of Support Services is governed by
the terms and conditions for the applicable service offering (if any), the
policies and programmes described in the Documentation, and/or other
Eaton-provided Materials.
</p>
<p>
12.2 Any additional supplemental Materials provided to you as part of the
Support Services shall be considered part of the Product Software, as
applicable, and subject to the provisions of this Agreement.
</p>
<h3>
13 DISCLAIMER OF WARRANTY
</h3>
<p>
13.1 To the extent permitted by applicable law, you expressly acknowledge
and agree that use of the product software is at your sole risk and that
the entire risk as to satisfactory quality, performance, accuracy and
effort of the product software is with you.
</p>
<p>
13.2 To the fullest extent permitted by applicable law, the Product
Software, the Material and any information and any services performed or
provided by or in connection with the Product Software are provided on an
“as is” and “as available” basis, with all bugs and faults and without
warranty of any kind. Eaton, its affiliates, subsidiaries, and authorized
representatives hereby disclaim all warranties and conditions of any kind
with respect to the product software and any services, either express,
implied, statutory, or otherwise, including, but without limitation, any
implied warranties and/or conditions of merchantability, of satisfactory
quality, of fitness for a particular purpose, security, completeness,
timeliness, accuracy, quiet enjoyment, title, freedom from computer
viruses, and of non-infringement of third party rights. Neither Eaton, nor
any of its affiliates or subsidiaries, warrant that the functions or
services contained in, accessed from, performed by, displayed on, linked
to/from, or provided by, the product software will meet your requirements,
that the operation of the product software or services will be
uninterrupted, error-free, timely, secure, or that defects or errors in the
product software or services will be corrected, or that the product
software will be compatible with any system, or that the product software
will be free from worms, viruses, malware, Trojan horses, or other harmful
or disabling components.
</p>
<p>
13.3 No oral or written information or advice given by Eaton, its
affiliates, subsidiaries, or any of their respective authorized
representatives shall create a warranty. You assume the entire cost of any
and all necessary repairs in the event you experience any loss or damage
arising from the use of the product software or any related goods or
services. If you are dissatisfied with the product software and/or any
related goods or services, your sole and exclusive remedy is to discontinue
using the product software.
</p>
<p>
<h3 name="_Ref56549033">14 LIMITATION OF LIABILITY</h3>
</p>
<p>
14.1 Nothing in this agreement shall exclude or limit Eaton’s liability for
death or personal injury resulting from its negligence or of its officers,
representatives their servants, agents, affiliates, employees or any other
liability which may not be limited or excluded under applicable law. In no
event shall Eaton nor any of its officers or other representatives be
liable for any loss or damages arising out of or in connection with your
use, inability to use or reliance on any facilities, services, products
and/or content offered through or from the product software, including, but
not limited to, direct loss, loss of data, work stoppage, service
interruption, computer failure, system failure, device damage or
malfunction, loss of income, profit or opportunity, loss of or damage to
property and claims of third parties or for any indirect or consequential
loss whatsoever, even if Eaton has been advised of the possibility of such
loss or damages, or such loss or damages were reasonably foreseeable.
</p>
<p>
14.2 To the fullest extent permitted by law, Eaton, its affiliates,
suppliers, licensors, and any other party involved in creating, producing
or delivering the product software makes no warranties, either express or
implied, about the product software. The product software is provided "as
is” and “as available.”
</p>
<p>
14.3 Except for your indemnification obligations pursuant to Clause 15 of
this agreement, in no event will the aggregate liability (whether arising
out of liability under breach of contract, tort (including but not limited
to negligence), misrepresentation, breach of statutory duty, breach of
warranty or claims by third parties arising from any breach of this
agreement) of Eaton or its employees or agents to you or to any third party
for damages, direct or otherwise, arising out of or in connection with this
agreement exceed the lower of $100 (one hundred United States dollars) or
the cost of the product software, regardless of the cause or form of
action, and whether such claims are grounded in contract, tort, strict
liability or any other legal theory, notwithstanding any failure of
essential purpose of any limited remedy.
</p>
<p>
14.4 Nothing in this agreement shall exclude or limit your liability under
Clause 11 for any failure to pay any fees due hereunder or for any breach,
misuse or infringement of Eaton’s intellectual property rights under Clause
21.
</p>
<p>
14.5 If you use the Product Software for commercial, business or resale
purpose we will have no liability to you for any loss of profit, loss of
business, business interruption, or loss of business opportunity.
</p>
<p>
14.6 Each provision of this Clause 14 excluding or limiting liability shall
be construed separately, applying and surviving even if for any reason one
or the other of these provisions is held inapplicable or unenforceable and
shall remain in force notwithstanding the termination of this agreement,
howsoever arising.
</p>
<p>
<h3 name="_Ref56548932">15 INDEMNIFICATION</h3>
</p>
<p>
15.1 You agree to indemnify, defend, and hold harmless Eaton, including its
officers, directors, employees, affiliates, subsidiaries, agents,
licensors, authorized representatives, attorneys, business partners, and
respective successors and assigns (the “    <strong>Indemnified Parties</strong>”) from and against any and all claims,
demands, actions, liabilities, judgments, awards, losses, damages, costs
and expenses (including reasonable legal fees, costs of defence, and
direct, indirect, punitive, special, individual, consequential, or
exemplary damages), Eaton or any of the Indemnified Parties suffer in
relation to, arising from, or from the purpose of avoiding, any claim or
demand from a third party that relates to your: (a) breach or violation of
this Agreement; (b) infringement, misappropriation or any violation of the
rights of any other party from use of the Product Software in violation of
this Agreement; (c) violation or non-compliance with any applicable law,
rule, guidelines, acts, decrees, orders or regulations; (d) use, alteration
or export of the Product Software (or any component thereof) in violation
of this Agreement; and (e) the use of the Product Software by you or any
person using your account.
</p>
<p>
15.2 Eaton and its affiliates reserve the right to assume the exclusive
defence and control of any claims or actions subject to indemnification by
you and all negotiations for its settlement or compromise, and you agree to
fully cooperate with Eaton and its affiliates upon request by Eaton.
</p>
<h3>
16 AMENDMENTS TO THIS AGREEMENT
</h3>
<p>
16.1 Eaton reserves the right to amend, modify, update or substitute any of
the provisions of this Agreement at any time. You have the right to
withdraw from this Agreement if you do not accept any amendments,
modifications, updates or substitution of any of the provisions of this
Agreement and in such an event you must cease all access and use of the
Product Software immediately. By continuing to use the Product Software
after Eaton posts or otherwise notifies you of any changes, you accept and
agree to the terms and conditions, as modified.
</p>
<h3>
17 FOR AUTHORIZED PARTIES IN CALIFORNIA
</h3>
<p>
17.1 In compliance with California Civil Code §1789.3, if you reside in
California you have the right to contact Eaton with any complaints or to
seek additional information. You may email Eaton at
dataprotection@eaton.com.
</p>
<p>
17.2 If you reside in California and have any questions or complaints about
the use of the Eaton provided Product Software you may also contact: The
Complaint Assistance Unit of the Division of Consumer Services of the
California Department of Consumer Affairs through writing at 400 R Street,
Suite 1080, Sacramento, CA 95814, or by telephone at (916) 445-1254 or
(800) 952-5210. Hearing impaired persons may call (916) 928-1227 or (800)
326-2297 via TTY device. For further details, please visit
<a href="https://www.dca.ca.gov/about_us/contactus.shtml">
    https://www.dca.ca.gov/about_us/contactus.shtml
</a>
.
</p>
<p>
17.3 You acknowledge and agree that this Clause 17 shall only apply to you
if you are resident in California.
</p>
<h3>
18 ENFORCEMENT RIGHTS
</h3>
<p>
18.1 Eaton is not obligated to monitor the access or use of the Product
Software, but Eaton reserves the right to do so for the purpose of
operating the Product Software, to ensure compliance with these terms, and
to comply with applicable law or other legal requirements. Eaton may
consult with and disclose unlawful conduct to law enforcement authorities;
and pursuant to valid legal process, Eaton may cooperate with law
enforcement authorities as part of an investigation and/or to prosecute
users who violate the law. In addition to any of its other rights or
remedies, Eaton reserves the right to suspend or terminate your access to
all or a portion of your Product Software account, without any liability,
if Eaton reasonably suspects that your use of the Product Software is
harming or threatening to harm Eaton’s systems, or in Eaton’s reasonable
opinion you have violated your responsibilities. Eaton reserves the right
to investigate any violation of these terms and any conduct that affects
the Product Software.
</p>
<p>
<h3 name="_Ref56549044">19 DATA PROTECTION</h3>
</p>
<p>
19.1 For the purposes of this Clause, personal data, data processor and
data controller shall have the meanings given to them in the General Data
Protection Regulation (the “<strong>GDPR</strong>”). You agree to comply
with your obligations as a controller in respect to any processing of
personal data and Eaton agrees to comply with its respective obligations
under GDPR.
</p>
<p>
19.2 Eaton is the data controller in relation to any personal data which
you have provided to it in order to receive its services. For information
on the use of any personal data which you have provided to Eaton please see
<a href="https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html"> https://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html. </a>
</p>
<p>
19.3 Eaton will at all times take all appropriate technical and
organisational measures against unauthorized or unlawful processing of
personal data and against accidental loss or destruction of, or damage to,
personal data. Although Eaton has undertaken these measures and the
requirements set out in GDPR, Eaton cannot guarantee that your personal
data is secure when it is sent or transferred by unsecured means.
</p>
<p>
<h3 name="_Ref56549069">20 CONFIDENTIAL INFORMATION</h3>
</p>
<p>
20.1 All information provided via the Product Software is Eaton’s
confidential information. You agree to protect Eaton’s confidential
information, using the same degree of care used to protect your own
confidential or proprietary information, but in any case, using no less
than a reasonable degree of care.
</p>
<p>
20.2 You agree to only use Eaton’s confidential information for the
purposes of obtaining the benefit set out in this Agreement and for no
other purpose. You agree not to use or disclose Eaton’s confidential
information without the prior written consent of Eaton, except to share it
with your employees who have a need to know the information and are bound
by a duty of confidentiality covering the information that is at least as
restrictive as the obligations in this Agreement. You agree not to
otherwise disclose such information to any third party without the prior
written consent of Eaton. You shall be liable to Eaton for any breach of
the confidentiality obligations in this Clause 20 of this Agreement by your
employees.
</p>
<p>
20.3 Except for personally identifiable information/personal data, the use
and disclosure of which is addressed in the Privacy Statement for the
Product Software, any and all information and content provided by you to
Eaton is provided on a non-proprietary and non-confidential basis,
regardless of whether the information or content is marked or otherwise
identified as confidential or proprietary. You agree that Eaton has a
royalty-free, perpetual, irrevocable, worldwide, non-exclusive right and
license to use, reproduce, modify, adapt, publish, translate, create
derivative works from, distribute, perform, and display any provided
information or content for the purpose of operating and/or marketing the
services or any related services rendered by Eaton. This license includes
any right of publicity rights that may be present in the provided
information or content.
</p>
<p>
20.4 The provisions of this Clause 20 shall survive the expiration or
termination of this Agreement.
</p>
<p>
<h3 name="_Ref56548908">21 INTELLECTUAL PROPERTY OWNERSHIP</h3>
</p>
<p>
21.1 This Agreement does not transfer any Intellectual Property Rights from
Eaton to you. Except for the express licenses granted herein, all right,
title and interest (including Intellectual Property Rights) in and to any
intellectual property owned, created or independently developed by Eaton,
including, but not limited to, the Product Software and any derivative
work, customisation, modification or enhancement thereof (including all
Intellectual Property Rights in any of the foregoing), whether developed
prior to, during, or after this Agreement, will remain solely with Eaton
and its licensors. Eaton grants no implied licenses hereunder.
</p>
<p>
21.2 You may provide suggestions, comments or other feedback (“    <strong>Feedback</strong>”) relating to the Product Software. Your
Feedback, even if designated as confidential, shall not, absent a separate
written agreement, create any confidentiality obligation for Eaton. Eaton
shall be free to use, disclose, reproduce, license or otherwise distribute
and exploit such Feedback as it sees fit, entirely without obligation or
restriction of any kind on account of intellectual property rights or
otherwise.
</p>
<p>
21.3 You may print off one copy, and may download extracts, of any page(s)
of the Materials solely for internal business purposes. Any paper or
digital copies of any Materials which you have printed off or downloaded in
any way must not be modified, and you must not use any illustrations,
photographs, video or audio sequences or any graphics separately from any
accompanying text.
</p>
<p>
21.4 The content on the Product Software, including all information, text,
graphics, images, hyperlinks, illustrations, designs, icons, photographs,
documents, products, computer programs, services and written and other
materials (collectively, the “<strong>Materials</strong>”), and such
information is for general guidance purposes only.
</p>
<p>
21.5 Unless otherwise noted, all Materials are copyrights, trademarks,
trade dress and/or other intellectual properties owned by, controlled by or
licensed to Eaton or third parties (hereinafter, the “    <strong>Third-Party Providers</strong>”).
</p>
<p>
21.6 Except as stated herein, and to the extent permitted by law, none of
the Materials may be copied, reproduced, distributed, republished,
downloaded, displayed, posted or transmitted in any form or by any means,
including, but not limited to, electronic, mechanical, photocopying,
recording, or otherwise, without the prior express written permission of
Eaton or the Third-Party Provider.
</p>
<p>
21.7 Any use of these Materials on any other website or networked computer
environment for any purpose is prohibited. Any unauthorized use of any
Materials contained on this Product Software may violate copyright,
trademark, and other laws, including but not limited to laws of privacy and
publicity, and may result in severe civil and criminal penalties.
</p>
<h3>
22 TERMINATION OR SUSPENSION
</h3>
<p>
22.1 This Agreement and the license granted hereunder, shall come into
force on the creation of your Product Software account and shall continue
in full force and effect unless this Agreement is terminated in accordance
with its terms.
</p>
<p>
22.2 Eaton reserves the right, in its sole discretion and without notice to
you, to suspend, terminate, modify or delete an account or access to the
Product Software or parts thereof, if you are, or Eaton reasonably suspects
that you are, failing to comply with any of the provisions of this
Agreement or for any actual or suspected illegal or improper use of the
Product Software. If you use multiple accounts, if Eaton does take action
against you, you may have action taken against all your accounts.
</p>
<p>
22.3 For the avoidance of doubt, any wilful unauthorized use, copying,
modification, reverse engineering, disclosure, distribution or sublicensing
of the Intellectual Property Rights in the Product Software or any related
methods, algorithms, techniques or processes by you, your employees,
agents, representatives, officers or directors will be deemed a material
breach of this Agreement that cannot be cured, and termination may be
immediate.
</p>
<p>
22.4 Upon termination for any reason:
</p>
<p>
(i) all rights and licenses granted to you under this Agreement shall
cease;
</p>
<p>
(ii) you must cease all activities authorized by this Agreement, including
your use of the Product Software;
</p>
<p>
(iii) you must immediately return or destroy all confidential information
of Eaton in your possession, provided that you shall not be required to
delete Eaton’s confidential information that is and remains stored solely
on backup storage pursuant to your standard backup retention procedures if
only persons of advanced information technology knowledge and ability would
be able to locate and access such information (but such information shall
nonetheless remain subject to confidentiality obligations contained
herein);
</p>
<p>
(iv) we may remotely access your devices and remove the Product Software
from them and cease providing you with access to the Product Software.
</p>
<p>
<h3 name="_Ref56548967">23 LINKS</h3>
</p>
<p>
23.1 The Product Software may contain links to third party websites,
services and/or display advertisements for third parties (together, “    <strong>Third Party Links and Ads</strong>”). Such Third Party Links and
Ads are not under Eaton’s control. Eaton disclaims all liability and
responsibility for any Third Party Links and Ads and you acknowledge and
agree that Eaton is not responsible or liable for: (a) the availability or
accuracy of such Third Party Links and Ads; or (b) the contents, products
or services on or available from such Third Party Links and Ads. Your use
of Third Party Links and Ads is at your own risk and is subject to the
terms and conditions of the applicable third party. Eaton provides Third
Party Links and Ads for your convenience and does not review, approve,
monitor, endorse, warrant, or make any representations with respect to
Third Party Links and Ads. You will need to make your own independent
judgement about whether to use any such independent sites, including
whether to buy any products or services offered by them.
</p>
<h3>
24 REPRESENTATIONS, WARRANTIES, COVENANTS AND DISCLAIMERS
</h3>
<p>
24.1 You undertake, represent and warrant that:
</p>
<p>
(i) you shall comply, at your own expense, with all applicable present or
future laws, statutes, instruments, regulations, orders, directives,
enactments, including any amendment, extension or replacement thereof which
is in force from time to time and which in any way relates to this
Agreement and/or the provision of the Product Software or results from your
obligations under this Agreement. Without limiting the foregoing, you shall
comply with all contracting and procurement regulations associated with the
Product Software;
</p>
<p>
(ii) you have full power and authority to enter into this Agreement;
</p>
<p>
(iii) you shall conduct your business in a manner that reflects favourably
at all times on the Product Software and the name and goodwill of Eaton;
</p>
<p>
(iv) you shall make no representations, warranties, or guarantees on behalf
of Eaton;
</p>
<p>
(v) you shall refrain from amending or varying this Agreement.
</p>
<p>
24.2 Eaton makes no representations or warranties of any kind regarding the
Product Software, the Material, information or any other matter, either
express or implied, including, but not limited to implied warranties of
fitness for a particular purposes, merchantability, title, accuracy/freedom
from error, non-infringement or otherwise. You are not authorized to make
any warranty commitment on Eaton’s behalf, whether written or oral. You
understand that the Product Software may include hyperlinks to other
websites or content or resources. Eaton has no control over any websites or
resources which are provided by companies or persons other than Eaton. You
acknowledge and agree that Eaton is not responsible whatsoever for any harm
suffered by you on or in any way due to any third party websites or
resources, even where they are accessed from or referred or linked to such
sites by the Product Software. You acknowledge and agree that Eaton is not
responsible for the availability of any such external sites or resources,
and does not endorse any advertising, products or other materials on or
available from such websites or resources. You acknowledge and agree that
Eaton is not liable for any loss or damage which may be incurred as a
result of the availability of those external sites or resources, or as a
result of any reliance placed by you on the completeness, accuracy or
existence of any advertising, products or other materials on, or available
from, such web sites or resources.
</p>
<p>
<h3 name="_Ref56548928">25 FORCE MAJEURE</h3>
</p>
<p>
25.1 Notwithstanding anything else contained in this Agreement, Eaton shall
not be liable for any delay in providing the Product Software or support
for the Product Software if such delay arises from or is attributable to
acts, events or omissions beyond its reasonable control, including (but not
limited to) pandemics, epidemics or endemics, nuclear accident, acts of
God, war or terrorist activity, riot, civil commotion, malicious damages
(including malicious damage involving your employees or your
sub-contractors), compliance with any law or governmental order or
regulation, accident, industrial action by employees of any provider of
electrical power, breakdown of plant or machinery, fire, flood or storm (a
“<strong>Force Majeure Event</strong>”).
</p>
<p>
25.2 The performance of Eaton shall be suspended during the period that the
Force Majeure Event persists and Eaton shall be granted an extension of
time for performance equal to the period of the delay arising as a result
of the Force Majeure Event.
</p>
<p>
25.3 If a Force Majeure Event continues for more than sixty (60) calendar
days, Eaton may terminate this Agreement immediately by notice in writing
and neither shall be liable to the other by reason of this termination.
</p>
<h3>
26 MISCELLANEOUS
</h3>
<p>
26.1 If a term is found unenforceable or invalid, that term will be
enforced to the maximum extent permissible and the remaining provisions of
the Agreement will remain in full force and effect and an enforceable term
will be substituted reflecting our intent as closely as possible. You may
not assign or transfer any of your rights under this Agreement, and any
such attempt will be void. Eaton may freely assign or transfer its rights
to any of its affiliates or subsidiaries, or to any successor in interest
of any business associated with the Product Software. Subject to the
foregoing, this Agreement will bind and ensure to the benefit of the
parties, their successors and permitted assigns. Eaton’s failure to enforce
a term of this Agreement is not a waiver of its right to do so later. No
failure or delay by Eaton or its affiliates to exercise any right or
enforce any obligation shall impair or be construed as a waiver or ongoing
waiver of that or any other right or power. Waiving one breach will not be
construed to waive any succeeding breach. All waivers must be in writing
and signed by the party waiving rights.
</p>
<p>
<h3 name="_Ref56548899">27 REGULATORY MATTERS</h3>
</p>
<p>
27.1 The Product Software, Documentation and Materials as well as parts of
any of these (e.g. new versions, releases, updates, upgrades, patches,
fixed or correction of the Product Software) are subject to export laws of
various countries, including, without limitation, the laws of the United
States, the EU and Ireland (“<strong>Export Laws</strong>”). You agree that
you will not submit the Product Software, Documentation or other Materials
or parts of any of these to any government agency for licensing
consideration or other regulatory approval without the prior written
consent of Eaton, and that you will not export, re-export or import any
Product Software, Documentation and/or Materials to countries, persons or
entities prohibited by any applicable Export Law. You represent and warrant
that you are not located within an embargoed nation and that you are not
otherwise prohibited under the Export Laws from receiving access to or
using the Product Software, Documentation or other Materials. In that
context, you are responsible for complying with all applicable Export Laws.
If Eaton wants to deliver and/or grant access to the Product Software,
Documentation, Materials, or parts of any of these directly to you, you
will support Eaton in obtaining any required authorization, approval or
other consent from the competent authorities, by providing any necessary or
useful declarations or other necessary or useful information, e.g. end user
certificates, as may be requested by Eaton. You acknowledge that the
delivery of and/or granting of access to the Product Software,
Documentation and Materials as well as parts of any of these may be subject
to the prior obtaining of export or import authorisations or both from the
competent authorities and that this process may (i) considerably delay or
prevent the delivery of and/or granting of access to the Product Software,
Documentation and Materials or part of any of these, (ii) impact Eaton’s
ability to provide services and (iii) lead to Eaton having to limit,
suspend or terminate your access to any services.
</p>
<p>
27.2 Eaton assumes no responsibility or liability:
</p>
<p>
(i) For any delay caused in the delivery and/or granting of access to the
Product Software, Documentation and Materials or parts of any of these due
to export or import authorizations or both having to be obtained from the
competent authorities;
</p>
<p>
(ii) If any required authorization, approval or other consent for the
delivery of and/or granting of access to Product Software, Documentation
and Materials or parts of these cannot be obtained from the competent
authorities; and
</p>
<p>
(iii) If the delivery of and/or granting of access to the Product Software,
Documentation and Materials or parts of any of these is prevented due to
applicable Export Laws; and
</p>
<p>
(iv) If access to any services has to be limited, suspended or terminated
due to applicable Export Laws.
</p>
<p>
27.3 Eaton may terminate this Agreement with thirty (30) days’ prior
written notice if Eaton may not deliver or grant access to the Product
Software, Documentation and Materials to you due to an embargo or other
comparable trade sanction, which is expected to be in place for six (6)
months or longer.
</p>
<p>
27.4 If the Product Software is licensed to agencies of the U.S.
Government, the Product Software is a "commercial item" as that term is
defined at 48 C.F.R. § 2.101, consisting of "commercial computer software"
and "commercial computer software documentation", as such terms are used in
48 C.F.R. § 12.212, and is provided to the U.S. Government only as a
commercial end item. Consistent with 48 C.F.R. § 12.212 and 48 C.F.R. §§
227.7202-1 through 227.7202-4, all U.S. Government End Users acquire the
Product Software with only those rights set forth herein.
Contractor/manufacturer is Eaton Corporation, 1000 Eaton Boulevard,
Cleveland, Ohio 44122.
</p>
<h3>
28 GOVERNING LAW AND JURISDICTION
</h3>
<p>
28.1 To the extent not prohibited by law, You agree that this Agreement and
all disputes, claims, actions, suits or other proceedings arising hereunder
shall be governed by, and construed in accordance with, the substantive law
of the State of Ohio applicable to contracts wholly made and to be
performed within the State of Ohio, and to irrevocably submit to the sole
and exclusive jurisdiction of the courts of Ohio or the Federal courts of
the Northern District of Ohio, and to irrevocably consent to the exercise
of personal jurisdiction by such courts and waive any right to plead, claim
or allege that Ohio is an inconvenient forum.
</p>
<p>
<h3>29 AGREEMENT</h3>
</p>
<p>
29.1 This Agreement (and any associated order form or other agreements
referenced herein) constitutes the entire and exclusive agreement between
you and Eaton with respect to the subject matter of this Agreement, and
supersedes and replaces any other prior or contemporaneous agreements, or
terms and conditions applicable to the subject matter of this Agreement. No
provisions in your purchase orders, or in any other business forms employed
by you, will supersede the terms and conditions of this Agreement.
</p>
<p>
30 CONTACT US
</p>
<p>
Any questions regarding this Agreement should be directed to Eaton at:    <strong></strong>
</p>
<p>
Eaton
</p>
<p>
Attn: IP Law Group
</p>
<p>
1000 Eaton Boulevard
</p>
<p>
Mail Code 4N
</p>
<p>
Cleveland, OH 44122
</p>
<p>
Eaton
</p>
<p>
Attn: Global Data Protection and Privacy Office
</p>
<p>
1000 Eaton Boulevard
</p>
<p>
Cleveland, OH 44122
</p>
<p>
Email:    <a href="mailto:dataprotection@eaton.com">dataprotection@eaton.com</a>
</p>
<br clear="all"/>
<p align="center">
<strong>APPENDIX 1A</strong>
<br>
Third Party Software
</p>
<p align="left">
<a href="/assets/licenses/licenses.csv" target="_blank">Third Party Licences</a>
</p>

<p align="center">
<strong>APPENDIX 1B</strong>
<br>
Eaton Open Source Components

</p>

<p align="left">	
<a href="https://pxblue.github.io/" target="_blank">Power Xpert Blue</a>

</p>

<br clear="all"/>
`